import React from 'react';
import {IPropsView} from '../Config/PopUp.types';
import closeIcon from '../images/close popup.png';
import '../Style/popUp.css';

const PopUp = ({onLoad, type, mainClass, children, title, subTitle, close, innerTitleClass = 'inner-title'}: IPropsView) => (
    // eslint-disable-next-line react/no-unknown-property
    <div className='popUp' onLoad={onLoad && onLoad}>
        <div id={`inner-${type}`} className={mainClass ? `${mainClass} inner-popup` : 'default-size inner-popup'}>
            {type === 'no-connection' && children}
            {title && <p className={innerTitleClass}>{title}</p>}
            {subTitle && <p className={`popup-subTitle popup-subTitle-${type}`}>{subTitle}</p>}
            {(type === 'upload' || type === 'accuracy' || type === 'mail' || type === 'synthetic' || type === 'drag_and_drop' || type === 'small') && children}
            {close && <img className='close' src={closeIcon} alt='close popup' onClick={close}/>}
        </div>
    </div>
);

export default PopUp;
